import React from 'react';

import { useTranslation } from '@lt/localization';
import ReviewsItem from 'src/components/Reviews/ReviewsItem';
import {
  RECENT_REVEIW_MAX_HEIGHT,
  RECENT_REVEIW_MAX_CONTENT_LENGTH,
} from '../../../../constants';
import ShowReviewsButton from '../ShowReviewsButton';

import styles from '../../reviews.module.css';

const LastReview = ({ item, isMobile }) => {
  const { t } = useTranslation();
  return (
    item && (
      <>
        <div className={styles.ltHotelReviewsLast}>
          <h3 className="like-h3">{t('hotel.reviews.last')}</h3>
          <ReviewsItem
            {...item}
            maxContainerHeight={RECENT_REVEIW_MAX_HEIGHT}
            maxContentLength={RECENT_REVEIW_MAX_CONTENT_LENGTH}
            showExpandButton={false}
            isMobile={isMobile}
          />
          <ShowReviewsButton />
        </div>
      </>
    )
  );
};

export default LastReview;
